angular.module('vastdesk').
  component('forecastSupply', {
    bindings: {
      formName: '@',
      formId: '@',
      supplyType: '@',
      supplyTargetingSource: '@',
      selectedTags: '<',
      selectedRouters: '<',
      selectedPartners: '<',
      selectedLabels: '<',
      supplyTargetingSourceOptions: '<',
      includeInactiveTags: '<',
      supplyFormat: '<'
    },
    template: require('../templates/forecastSupply.html'),
    controllerAs: '$forecastSupplyCtrl',
    controller: ['$scope', function($scope) {
      var self = this;

      this.showSupplyTargeting = function () {
        return ['include', 'exclude'].includes(this.supplyType);
      };

      this.setSupplyType = function(value) {
        self.supplyType = value;
        const targetingSource = !self.showSupplyTargeting() ? "partners" : self.supplyTargetingSource;
        self.setSupplyTargetingSource(targetingSource);
      };

      this.setSupplyTargetingSource = function(value) {
        self.supplyTargetingSource = value;
      };

      this.showIncludeInactiveTagsToggle = function() {
        return this.showSupplyTargeting() && ['partners', 'labels'].includes(this.supplyTargetingSource);
      };

      this.setSupplyFormat = function(value) {
        self.supplyFormat = value;
      };

      this.showSupplyFormat = function() {
        return ['include', 'exclude', 'run_of_network'].includes(self.supplyType);
      };

      this.$onInit = function() {
        const initialData = self.supplyFormat;

        if (typeof initialData === 'object' && initialData !== null && Array.isArray(initialData.values)) {
          self.supplyFormat = (initialData.values.length > 0) ? initialData.values[0] : '';
        } else {
          self.supplyFormat = initialData || '';
        }
        
        setTimeout(() => {
          self.setSupplyTargetingSource(self.supplyTargetingSource);
        }, 0);
      };
    }],
});